var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17906_113093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EBF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9404 8L19.7812 8.54043V24.221L19.9404 24.3797L27.219 20.0773L19.9404 8Z",
    fill: "#479DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9428 8L12.6641 20.0773L19.9428 24.3797V16.7688V8Z",
    fill: "#99C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9412 25.7572L19.8516 25.8666V31.4522L19.9412 31.714L27.2243 21.457L19.9412 25.7572Z",
    fill: "#005FCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9428 31.715V25.7582L12.6641 21.458L19.9428 31.715Z",
    fill: "#99C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9453 24.3795L27.2239 20.077L19.9453 16.7686V24.3795Z",
    fill: "#70B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 20.077L19.9428 24.3795V16.7686L12.6641 20.077Z",
    fill: "#005FCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17906_113093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEth);
export default __webpack_public_path__ + "static/media/logo-eth.0e57036172f9a72c5ebedcaf53b52219.svg";
export { ForwardRef as ReactComponent };